module.exports = __webpack_public_path__ + "catalog/items/kitchen/one-half-sink-with-drainer/one-half-sink-with-drainer.svg";